import React from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { getMaterials } from '../../api/material'
import PageList from '../../components/PageListAPI'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';

export default function StorageMaterial(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='storageMaterial'
        title='Остатки на складе'
        columns={[
          { id: 'name', name: 'Наименование' },
          { id: 'typeMark', name: 'Тип, марка' },
          { id: 'vendorCode', name: 'Артикул' },
          { id: 'storage', name: 'На складе', align: 'right' },
          { id: 'storageUnit', name: 'Ед. изм.' },
        ]}
        loadAPI={{
          param: {
            id: props.match.params.idProject,
          },
          querty: {
            type: 'storage'
          },
          request: getMaterials
        }}
        click={false}
        headerLink={can(SLUGS.DOC.REMOVAL_P.MANAGE)&&<RemoteLink {...props} />}
        {...props}
      />
    </div>
  )
}

function RemoteLink(props) {
  const toLinkRemote = React.forwardRef((props1, ref) => (<Link ref={ref} to={`${props.match.url}/removal/add`} {...props1} />))
  return (<Button color='primary' component={toLinkRemote} >Списать</Button>);
}
